module.exports = __webpack_public_path__ + "static/media/Loss of Driving License.9a0d8a59.png";